import type { Process, RollupWithTagsAndCountsAndRange } from "types/types";
import { PnlCategoriesEnum } from "types/enums";
import styled from "styled-components/macro";
import {
  PNL_COLORS,
  BUTTERFLY_LEFT_WING_CATEGORIES,
  BUTTERFLY_RIGHT_WING_CATEGORIES,
} from "constants/constants";
import { highlightTags } from "components/Dashboard/PnlSummaryChart/pnlSummaryChartUtils";

type HorizontalBarstackProps = {
  rollupDisplay: RollupWithTagsAndCountsAndRange;
  process: Process;
};

/** displays one P&L summary in a horizontal stack, similar to the Butterfly chart */
const HorizontalBarstack = ({
  rollupDisplay,
  process,
}: HorizontalBarstackProps) => {
  return (
    <HorizontalBarstackStyles>
      {BUTTERFLY_LEFT_WING_CATEGORIES.filter(
        ({ category }) => (rollupDisplay?.[category] || 0) > 0
      ).map(({ category }, idx) => (
        <div
          key={category}
          className={`pnlBarHorizontal profit leftStack ${category}${
            idx === 0 ? " first" : ""
          }`}
          style={{
            backgroundColor: PNL_COLORS[category],
            flexGrow: rollupDisplay?.[category] || 0,
          }}
          {...getHighlightHandlers({ category, processId: process.id })}
        />
      ))}
      <div className="barstackSpacer" />
      {BUTTERFLY_RIGHT_WING_CATEGORIES.filter(
        ({ category }) => (rollupDisplay?.[category] || 0) > 0
      ).map(({ category }, idx, filteredCategories) => (
        <div
          key={category}
          className={`pnlBarHorizontal loss rightStack ${category}${
            idx === filteredCategories.length - 1 ? " last" : ""
          }`}
          style={{
            backgroundColor: PNL_COLORS[category],
            flexGrow: rollupDisplay?.[category] || 0,
          }}
          {...getHighlightHandlers({ category, processId: process.id })}
        />
      ))}
    </HorizontalBarstackStyles>
  );
};

export default HorizontalBarstack;

const HorizontalBarstackStyles = styled.div`
  display: flex;
  flex-grow: 1;
  height: 26px;
  align-items: center;
  .barstackSpacer {
    height: 28px;
    width: 9px;
    border-left: 2px solid black;
    border-right: 2px solid black;
    box-sizing: border-box;
  }
  .pnlBarHorizontal {
    &:hover {
      opacity: 0.5;
    }
    height: 100%;
    box-sizing: border-box;
    &.leftStack {
      margin-left: 1px;
      &.first {
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
      }
    }
    &.rightStack {
      margin-right: 1px;
      &.last {
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
      }
    }
  }
`;

export function getHighlightHandlers({
  category,
  isOverall = false,
  processId,
}: {
  category: PnlCategoriesEnum | string;
  isOverall?: boolean;
  processId?: string;
}) {
  return {
    onMouseOver: () => {
      highlightTags({
        tag: category,
        doHighlight: true,
        isOverall,
        processId,
      });
    },
    onMouseOut: () => {
      highlightTags({
        tag: category,
        doHighlight: false,
        isOverall,
        processId,
      });
    },
  };
}
